import { RefObject } from 'react';

const PAGINATION_HEIGHT = 32;
const PADDING_HEIGHT = 48;
const INSTANCE_CARD_HEIGHT = 55;

export const useCalculatePaginationHeight = (containerRef: RefObject<HTMLDivElement | null>) => {
  const CONTAINER_HEIGHT = containerRef?.current?.clientHeight || 0;
  const AVAILABLE_HEIGHT = CONTAINER_HEIGHT - (PADDING_HEIGHT + PAGINATION_HEIGHT);
  const PAGE_SIZE = Math.floor(AVAILABLE_HEIGHT / INSTANCE_CARD_HEIGHT);
  const LIST_CONTAINER_SIZE = PAGE_SIZE * INSTANCE_CARD_HEIGHT;

  return {
    LIST_CONTAINER_SIZE,
    PAGE_SIZE,
  };
};
